import { createApi } from '@reduxjs/toolkit/query/react';

import {
  GET,
  GET_CLIENT_USERNAMES,
  LEADS_RESOURCE,
  PUT,
  SET_CLIENT_USERNAMES,
} from '@app/constants';
import { customBaseQuery } from '@app/services/rtkQuery/baseQuery';
import type { NAuth, NLeads } from '@app/types';

const API_URL_PART = LEADS_RESOURCE;

export const leadsApi = createApi({
  reducerPath: 'leadsApi',
  baseQuery: (props) => customBaseQuery(props),
  endpoints: ({ mutation, query }) => ({
    [GET_CLIENT_USERNAMES]: query<
      NLeads.ModelClientUsername[],
      { clientId: number; ActiveBranchId: NAuth.UserPrint['activeBranchId'] }
    >({
      query: (params) => ({
        url: `${API_URL_PART}/${GET_CLIENT_USERNAMES}`,
        method: GET,
        params,
      }),
    }),
    [SET_CLIENT_USERNAMES]: mutation<
      void,
      {
        ActiveBranchId: NAuth.UserPrint['activeBranchId'];
        Items: NLeads.ModelClientUsername[];
      }
    >({
      query: ({ Items, ...params }) => ({
        url: `${API_URL_PART}/${SET_CLIENT_USERNAMES}`,
        method: PUT,
        params,
        data: Items,
      }),
    }),
  }),
});

export const {
  useGetClientUsernamesQuery,
  useLazyGetClientUsernamesQuery,
  useSetClientUsernamesMutation,
} = leadsApi;
